export default __webpack_public_path__ + "static/media/americanexpressnew.72c73823.png";